module.exports = __webpack_public_path__ + "img/tab_sound_icon.0c8e77ba.svg";